import React, { createContext, useContext, useState } from "react";

const GlitchContext = createContext();

export const GlitchProvider = ({ children }) => {
    const [showGlitch, setShowGlitch] = useState(false);
    const [glitchOpacity, setGlitchOpacity] = useState(0); // Start at 0 for fade-in

    const triggerGlitch = () => {
        setShowGlitch(true);
        setGlitchOpacity(0); // Start invisible

        sessionStorage.setItem("glitchTransition", "true");

        setTimeout(() => {
            setGlitchOpacity(1); // Fade in
        }, 50); // Small delay to prevent instant appearance

        setTimeout(() => {
            setGlitchOpacity(0); // Fade out
        }, 1000); // Adjust timing for fade-in effect

        setTimeout(() => {
            setShowGlitch(false); // Hide completely after fade-out
        }, 2000);
    };

    return (
        <GlitchContext.Provider value={{ showGlitch, glitchOpacity, triggerGlitch }}>
            {children}
        </GlitchContext.Provider>
    );
};

export const useGlitch = () => useContext(GlitchContext);